module.exports = __webpack_public_path__ + "img/choices.2f85dfbd.svg";